var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { action, observable, computed } from 'mobx';
import { Api } from '@app/Api';
import { observer } from 'mobx-react';
import { Modal } from '@app/Components/Modal/Modal';
import { TaskInfo, TaskInfoFormModel } from '@app/Widgets/ManualTaskModals/TaskInfo';
import { appStore } from '@app/AppStore';
export var AddTaskModal = /** @class */ (function (_super) {
    __extends(AddTaskModal, _super);
    function AddTaskModal(props) {
        var _this = _super.call(this, props) || this;
        //@observable private _projectMap: ProjectGatesModel | null = null;
        _this._gates = [];
        _this._formData = new TaskInfoFormModel();
        _this._formData.projectId = props.projectId || 0;
        _this._formData.gateId = props.gateId;
        if (props.gateId) {
            _this._formData.gate = {
                value: props.gateId,
                label: props.gateCodeName || ''
            };
        }
        _this._formData.approver = appStore.currentPrincipal;
        return _this;
    }
    /*async componentDidMount() {
        const { projectId } = this.props;
        if(projectId) {
            this._projectMap = await Api.secured.getProjectWithGates(projectId);
            
        }
    }*/
    AddTaskModal.prototype.onFormChange = function (form) {
        this._formData = form;
        return Promise.resolve();
    };
    AddTaskModal.prototype._onTaskSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var projectId, gateId, approver, assignee, deadLine, description, title, checkListItemId, afterSave, onToggle, model;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        projectId = (_a = this._formData, _a.projectId), gateId = _a.gateId, approver = _a.approver, assignee = _a.assignee, deadLine = _a.deadLine, description = _a.description, title = _a.title;
                        checkListItemId = (_b = this.props, _b.checkListItemId), afterSave = _b.afterSave, onToggle = _b.onToggle;
                        if (!(deadLine && approver && assignee)) return [3 /*break*/, 4];
                        model = {
                            projectId: Number(projectId),
                            checklistItemId: checkListItemId,
                            gateId: Number(gateId) || undefined,
                            dueDate: deadLine,
                            approverPrincipalId: approver.id,
                            assignedToPrincipalId: assignee.id,
                            description: description,
                            title: title
                        };
                        return [4 /*yield*/, Api.secured.createManualTask({ body: model })];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, (afterSave === null || afterSave === void 0 ? void 0 : afterSave())];
                    case 2:
                        _c.sent();
                        return [4 /*yield*/, onToggle()];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AddTaskModal.prototype, "_isDisabled", {
        get: function () {
            return !(this._formData.projectId &&
                this._formData.gateId &&
                this._formData.deadLine &&
                this._formData.assignee &&
                this._formData.description &&
                this._formData.title &&
                this._formData.approver);
        },
        enumerable: false,
        configurable: true
    });
    AddTaskModal.prototype.render = function () {
        var _a;
        var projectName = (_a = this.props, _a.projectName), gateId = _a.gateId, isOpen = _a.isOpen;
        return (React.createElement(Modal, { isOpen: isOpen, headerTitle: "Add Task", maxWidth: "1000px", footerbuttons: this._getFooterButtons(), toggle: this.props.onToggle },
            React.createElement(TaskInfo, { projectName: projectName || '', form: this._formData, isReadOnly: false, config: {
                    isAttachmentsHidden: true,
                    isAnswerHidden: true,
                    isStateHidden: true,
                    isGateDisabled: !!gateId
                }, onChange: this.onFormChange })));
    };
    AddTaskModal.prototype._getFooterButtons = function () {
        return [
            {
                color: 'success',
                onClick: this._onTaskSave,
                disabled: this._isDisabled,
                title: 'Save'
            },
            {
                onClick: this.props.onToggle,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], AddTaskModal.prototype, "_gates", void 0);
    __decorate([
        observable
    ], AddTaskModal.prototype, "_formData", void 0);
    __decorate([
        action.bound
    ], AddTaskModal.prototype, "onFormChange", null);
    __decorate([
        action.bound
    ], AddTaskModal.prototype, "_onTaskSave", null);
    __decorate([
        computed
    ], AddTaskModal.prototype, "_isDisabled", null);
    AddTaskModal = __decorate([
        observer
    ], AddTaskModal);
    return AddTaskModal;
}(React.PureComponent));
